document.addEventListener('DOMContentLoaded', function () {

    const slider = document.querySelector('.testimonials-slider');

    if (!slider) return;

    const autoplayEnabled = slider.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(slider.dataset.speed, 10) || 4000;

    const swiper = new Swiper('.testimonials-slider', {

        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        speed: 700,
        grabCursor: true,
        watchOverflow: true,

        autoplay: autoplayEnabled ? {
            delay: autoplaySpeed,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        } : false,

        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },

        breakpoints: {

            768: {
                slidesPerView: 2,
                spaceBetween: 20
            },

            1200: {
                slidesPerView: 3,
                spaceBetween: 24
            }

        }

    });

});